const PROFILE_SCROLL_TOP = 0;
const PROFILE_SCROLL_CONTAINER = '.wrapper-main-content';

export function promptViewUserProfile(message: string): string {
  const browserWindow = window;
  return browserWindow.prompt(message);
}

export function scrollViewUserProfileToTop(): void {
  const browserWindow = window;
  const browserDocument = browserWindow.document;
  const content = browserDocument.querySelector(PROFILE_SCROLL_CONTAINER);
  if (content) { content.scrollTop = PROFILE_SCROLL_TOP; }
  browserWindow.scrollTo(PROFILE_SCROLL_TOP, PROFILE_SCROLL_TOP);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile.platform.ts